import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: 'input[type="number"]',
})
export class NumericInputPasteDirective {
  @HostListener('paste', ['$event']) onPaste(event: ClipboardEvent) {
    const pasted = (event.clipboardData || (window as any).clipboardData)?.getData('text') ?? '';
    const target = event.target as HTMLInputElement;
    const start = target.selectionStart ?? target.value.length;
    const end = target.selectionEnd ?? target.value.length;
    const resulting = target.value.substring(0, start) + pasted + target.value.substring(end);
    if (!/^-?\d*\.?\d*([eE][+-]?\d*)?$/.test(resulting)) {
      event.preventDefault();
    }
  }
}
